import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { NumberElement_element$data } from "../../__generated__/NumberElement_element.graphql";
import { NumberElement_screener$data } from "../../__generated__/NumberElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: NumberElement_element$data;
  screener: NumberElement_screener$data;
} & CommonElementProps;
const NumberElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(NumberElement, {
  element: graphql`
    fragment NumberElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment NumberElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
